import type { jsx } from '@emotion/react';

import * as React from 'react';

import type { ReviewAndSatisfactionScoreProps } from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationReviewsAndSatisfactionScoreItem';
import KeyInformationReviewsAndSatisfactionScoreItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationReviewsAndSatisfactionScoreItem';
import { KeyInformationItemNames } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  items: jsx.JSX.Element[];
} & ReviewAndSatisfactionScoreProps;

export const combineReviewsAndSatisfactionScore = ({
  items,
  productRating,
  totalReviewCount,
  enrollmentCount,
  satisfactionScore,
  satisfactionScoreSubtitle,
}: Props) => {
  const reviewsItem = items.find((item) => item?.key === KeyInformationItemNames.Reviews);
  const satisfactionScoreItem = items.find((item) => item?.key === KeyInformationItemNames.CourseSatisfactionScore);

  if (reviewsItem && satisfactionScoreItem) {
    const itemsToRender = items.filter((item) => item?.key !== KeyInformationItemNames.CourseSatisfactionScore);
    const reviewsItemIndex = items.findIndex((item) => item?.key === KeyInformationItemNames.Reviews);
    itemsToRender.splice(
      reviewsItemIndex,
      1,
      <KeyInformationReviewsAndSatisfactionScoreItem
        productRating={productRating}
        totalReviewCount={totalReviewCount}
        enrollmentCount={enrollmentCount}
        satisfactionScore={satisfactionScore}
        satisfactionScoreSubtitle={satisfactionScoreSubtitle}
        key={KeyInformationItemNames.Reviews}
      />
    );

    return itemsToRender;
  }

  return items;
};
